import { useMemo } from "react";

import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";

type LoggedOutIssueType = {
  issueType: string;
};

export const useLoggedOutIssueType = (): LoggedOutIssueType => {
  const [{ issueL1, issueL2, issueL3 }] = useLoggedOutContactUsContextStore([
    "issueL1",
    "issueL2",
    "issueL3",
  ]);

  const issueType = useMemo(() => {
    if (issueL3) {
      return `${issueL1}-${issueL2}-${issueL3}`;
    }
    if (issueL2) {
      return `${issueL1}-${issueL2}`;
    }
    return issueL1 ?? "";
  }, [issueL1, issueL2, issueL3]);

  return {
    issueType,
  };
};
